export interface Quotes {
  title: string;
  author: string;
}

/* 11 Quotes to be randomized: {title:'', author:''},*/
const quotes = [
  {
    title:"Programming isn't about what you know; it's about what you can figure out.",
    author:'Chris Pine'
  },
  {
    title:"The only way to learn a new programming language is by writing programs in it.",
    author:'Dennis Ritchie'
  },
  {
    title:"Sometimes it's better to leave something alone, to pause, and that's very true of programming.",
    author:'Joyce Wheeler'
  },
  {
    title:"In some ways, programming is like painting. You start with a blank canvas and certain basic raw materials. You use a combination of science, art, and craft to determine what to do with them.",
    author:'Andrew Hunt'
  },
  {
    title:"Testing leads to failure, and failure leads to understanding.",
    author:'Burt Rutan'
  },
  {
    title:"The best error message is the one that never shows up.",
    author:'Thomas Fuchs'
  },
  {
    title:"The most damaging phrase in the language is.. it's always been done this way",
    author:'Grace Hopper'
  },
  {
    title:"Don't write better error messages, write code that doesn't need them.",
    author:'Jason C. McDonald'
  },
  {
    title: "I think everybody in this country should learn how to program a computer because it teaches you how to think.",
    author:'Steve Jobs'
  },
  {
    title:"Measuring programming progress by lines of code is like measuring aircraft building progress by weight.",
    author:'Bill Gates'
  },
  {
    title:"The best thing about a boolean is even if you are wrong, you are only off by a bit.",
    author:'Anonymous'
  }
];

export default quotes;